import { Video } from '../libs/roomnew';
import interact from 'interactjs';

export default class MinimizedContent{
    constructor(){
        this.minimizedWindowsContainer = $('#minimized-windows-container')
        this.minimizedContainer = $('#minimized-windows')
        this.minimizedBadge;
        this.isBeingDragged = false;
        this.timeout;

        this.events();
    }

    events(){
        let mc = this;

        interact('#minimized-windows-container').styleCursor(false).draggable({
            inertia: true,
            // ignoreFrom: '.toast-join-requests-minimized',
            modifiers: [
                interact.modifiers.restrict({
                    restriction: 'body',
                    elementRect: { top: 0, left: 0, bottom: 1, right: 1 }
                }),

            ],
            onstart: function (event){
                mc.disableOpenWhileDrag()
            } ,
            listeners: {
                // call this function on every dragmove event
                move: mc.dragMoveListener,
                // call this function on every dragend event
                end (event) {
                    // mc.isBeingDragged = false;
                    mc.enableOpenWhileDrag()
                }
            }
        })

    }

    removeModeratorAccess(removeAll = false){
        let mc = this;
        if(removeAll){
            mc.minimizedContainer.html('');
            $('.modal').removeClass('minimized-modal fadeOutDown');
            return;
        }
        mc.minimizedContainer.children('div').each( function(e){
            // console.error($(this).attr('id'))
            if($(this).attr('id') != 'virtualBackgroundModal-minimized-icon'){
                let modalID = $(this).attr('id').split('-')[0];
                $(this).remove();
                $(`#${modalID}`).removeClass('minimized-modal fadeOutDown')
            }
        })
    }

    addMinimizedBadge(modal_id,icon){
        let mc = this;
        // if(mc.minimizedBadge){return}
        let minimizedInnerCircle = $('<div/>',{
            class: 'toast-minimized-inner-circle',
            html: icon
        });
        let minimizeContainer = $('<div/>', {
            class: 'toast-join-requests-minimized right',
            html: [minimizedInnerCircle],
        }).on('click', (e)=>{
            mc.maximizeModal(modal_id);
            // alert(modal_id)
        });

        mc.minimizedBadge = $('<div/>', {
        id: `${modal_id}-minimized-icon`,
        class: 'toast-join-requests-minimized-container minimized-badge-modal-'+modal_id,
        html: [minimizeContainer],
        });

        // if(mc.minimizedWindowsContainer.hasClass('left')){
        //     mc.minimizedContainer.append(mc.minimizedBadge);
        // }else{
            mc.minimizedContainer.prepend(mc.minimizedBadge);
        // }
        setTimeout(() => {
            mc.minimizedBadge.addClass('opaque')
        }, 30);
    };
    removeMinimizedBadge(modal_id){
        let mc = this;
        // if(mc.minimizedBadge){
        // mc.minimizedBadge.removeClass('opaque')
        $(`.minimized-badge-modal-${modal_id}`).removeClass('opaque')
        setTimeout(() => {
            // mc.minimizedBadge.remove();
            $(`.minimized-badge-modal-${modal_id}`).remove();
            // mc.minimizedBadge=undefined;
        }, 100);
        // }
    }
    minimizeModal(modal_id, icon){
        let mc = this;
        // if($(`.minimized-badge-modal-${modal_id}`).length){
        //     return;
        // }
        mc.updateWhenOnSide();
        $("#"+modal_id).removeClass("fadeInUp").addClass('fadeOutDown');
        setTimeout(() => {
            // $("#"+modal_id).addClass('minimized-modal');
            $(`#${modal_id}`).addClass('minimized-modal').modal('hide');
            if(!$(`.minimized-badge-modal-${modal_id}`).length){
                mc.addMinimizedBadge(modal_id, icon);
            }
        }, 100);
        //this.addMinimizedBadge(modal_id);
    };

    maximizeModal(modal_id){
        let mc = this;
        let timeout;
        // console.error(mc.isBeingDragged)
        if(mc.isBeingDragged){
            return;
        }
        mc.minimizedContainer.addClass('button-disabled');
        $('body').find(`.modal.fade.show`).each((i,modal)=>{
            // console.log("open modals",modal);
            if($(modal).attr('id') != modal_id){
                $(modal).modal('hide');
            }
        });
        $(`#${modal_id}`).removeClass('fadeOutDown minimized-modal').addClass("fadeInUp");
        setTimeout(() => {
            $(`#${modal_id}`).modal('show').removeClass('fadeInUp');
            // $("body").append(`<div class="modal-backdrop fade show"></div>`);
        }, 350);
        if(modal_id==='splitToConvo'){
            setTimeout(() => {
                Video.splitConversations.startEfss()
            }, 1000);
        }
        timeout = setTimeout(() => {
            mc.minimizedContainer.removeClass('button-disabled');
            clearTimeout(timeout);
        }, 1000);
        mc.removeMinimizedBadge(modal_id);
    };

    dragMoveListener (event) {
        let mc = this;
        // alert(mc.isBeingDragged);
        // mc.isBeingDragged = true;
        // console.error(event)
        var target = event.target
        // keep the dragged position in the data-x/data-y attributes
        var x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx
        var y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy

        // translate the element
        target.style.transform = 'translate(' + x + 'px, ' + y + 'px)'
        // let posX = event.clientX;
        // let posY = event.clientY;
        // console.error('pos x: ', posX, ' pos y: ', posY);
        // let leftSide = window.innerWidth / 2;
        // console.log(leftSide)
        // if(leftSide > posX){
        //     $('#minimized-windows-container').addClass('left');
        // }else{
        //     $('#minimized-windows-container').removeClass('left');
        // }

        // update the posiion attributes
        target.setAttribute('data-x', x)
        target.setAttribute('data-y', y)
    }

    updateWhenOnSide(){
        let mc = this;
        // console.log(mc.minimizedWindowsContainer[0].getBoundingClientRect().left)
        let x = parseInt(mc.minimizedWindowsContainer.css('transform').split(',')[4])
        let y = parseInt(mc.minimizedWindowsContainer.css('transform').split(',')[5])
        // console.log(x ,' ', y)
        if(mc.minimizedWindowsContainer[0].getBoundingClientRect().left <= 20){
            x = x+55;
            mc.minimizedWindowsContainer[0].style.transform = 'translate(' + x + 'px, ' + y + 'px)'
            mc.minimizedWindowsContainer.attr({'data-x': x, 'data-y': y});
            // console.log('fired')
        }
    }

    // updateMinimizedWindowPlacement(){
    //     let mc = this;
    //     console.error(Video.localVideoContainer.children('div').length)
    //     if(mc.minimizedContainer.children('div').length > 0){
    //         console.error(window.innerHeight - Video.sideVideos[0].getBoundingClientRect().bottom);
    //         if(Video.localVideoContainer.children('div').length > 0){
    //             mc.minimizedWindowsContainer.addClass('shift')
    //         }else if(window.innerHeight - Video.sideVideos[0].getBoundingClientRect().bottom < 150 && Video.localVideoContainer.children('div').length == 0){
    //             mc.minimizedWindowsContainer.addClass('shift')
    //         }else{
    //             mc.minimizedWindowsContainer.removeClass('shift');
    //         }
    //     }
    // }
    disableOpenWhileDrag(){
        let mc = this;
        // console.log('dragStart')
        if(mc.isBeingDragged){
            return;
        }
        mc.isBeingDragged = true;
    }
    enableOpenWhileDrag(){
        let mc = this;
        // console.log('dragend')
        clearTimeout(mc.timeout);
        mc.timeout =  setTimeout(() => {
            mc.isBeingDragged = false;
        }, 400);
    }
}
